import React, { useEffect, useRef, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { db } from '../../firebaseConfig'; 
import './CSS/StudentTwitchStreamDisplay.css';
import NoLiveImg from '../../img/NoLiveStream.png';
import { Typography } from '@mui/material';
import { useTranslation } from "react-i18next";

const StudentTwitchStreamDisplay = () => {
  const { t } = useTranslation();
  const { groupId } = useParams(); // Récupère l'ID du groupe depuis l'URL
  const [channel, setChannel] = useState(null);
  const embedRef = useRef(null);

  useEffect(() => {
    // Fonction pour récupérer le nom de la chaîne à partir de Firestore
    async function fetchChannel() {
      try {
        // Récupérer le document du groupe
        const groupDocRef = doc(db, 'groups', groupId);
        const groupSnap = await getDoc(groupDocRef);
        if (groupSnap.exists()) {
          const groupData = groupSnap.data();
          const teacherId = groupData.teacherId;
          if (teacherId) {
            // Récupérer le document du professeur correspondant
            const teacherDocRef = doc(db, 'teachers', teacherId);
            const teacherSnap = await getDoc(teacherDocRef);
            if (teacherSnap.exists()) {
              const teacherData = teacherSnap.data();
              if (teacherData.channel) {
                setChannel(teacherData.channel);
              }
            }
          }
        }
      } catch (err) {
        console.error("Erreur lors de la récupération du channel:", err);
      }
    }

    if (groupId) {
      fetchChannel();
    }
  }, [groupId]);

  useEffect(() => {
    if (!channel) return; // N'initialise pas le lecteur tant que le channel n'est pas récupéré

    // Charger le script Twitch Embed
    const script = document.createElement('script');
    script.src = "https://embed.twitch.tv/embed/v1.js";
    script.async = true;
    script.onload = () => {
      if (window.Twitch && window.Twitch.Embed) {
        new window.Twitch.Embed(embedRef.current, {
          width: '100%',
          height: '100%',
          channel: channel,
          layout: 'video',
          parent: [window.location.hostname]
        });
      }
    };
    document.body.appendChild(script);

    // Nettoyage lors du démontage du composant
    return () => {
      document.body.removeChild(script);
    };
  }, [channel]);

  return (
    <div className="twitch-container">
      {channel ? (
        <>
          <h2>{t("watch_live_of", { channel })}</h2>
          <div className="embed-wrapper">
            <div ref={embedRef} className="embed-responsive"></div>
          </div>
        </>
      ) : (
        <div>
        <img
          src= {NoLiveImg}
          alt={t("no_live_stream_alt")}
          style={{
            display: 'block',
            margin: '0 auto',
            maxWidth: '35%',
            height: 'auto',
          }}
        />
          <Typography sx={{
            display: 'flex', 
            justifyContent: 'center',  
            alignItems: 'center',   
            fontFamily: 'Arial',
            fontSize: '18px', 
            color: '#b0b0b0', 
            textAlign: 'center', 
            lineHeight: '1.5', 
            margin: '20px 0'
            }}> 
              {t("no_live_stream_now")}
            </Typography>
        </div>
      )}
    </div>
  );
};

export default StudentTwitchStreamDisplay;
